var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-widget',{attrs:{"title":_vm.$t('twofactor_stepper_title')},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('Index',{attrs:{"reset":_vm.twofactor,"redirect":true}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }